module.exports = __webpack_public_path__ + "static/media/educational-sponsor-bow-valley-college.3bf1a983.png";